import { render, staticRenderFns } from "./stream.vue?vue&type=template&id=087f6dc8&scoped=true&"
import script from "./stream.vue?vue&type=script&lang=js&"
export * from "./stream.vue?vue&type=script&lang=js&"
import style0 from "./stream.vue?vue&type=style&index=0&id=087f6dc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087f6dc8",
  null
  
)

export default component.exports